import { Button, Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../Styles/style";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import footerman from "../../../assets/images/footerman.png"
import arrow from "../../../assets/images/mix.png"

import Videostars from "../../../assets/images/mixer.mp4"
 const MixerButton  = styled(Button)`
 padding:20px;
 background-color:rgb(23, 77, 255);
 color:#fff;

 `
 const BuyNow = styled.a`
text-decoration: none;
background-color: #174DFF;
color:  #fff;
padding: 12px 20px;
border-radius: 50px;
display: flex;
max-width: 160px;
align-items: center;
margin-top:30px;

`
const ManImg = styled.img`
width: 100%;
height: auto;
max-width: 500px;
`
const GridWrapper = styled(Grid)`
display: flex;
align-items: center;
`
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`;
const GridVideo = styled(Grid)`
mix-blend-mode: lighten;
`;
const Section8_Team = () => {
  const theme = useTheme()
  return (
    <SectionWrapper p799="8rem 0 8rem 0" p599="8rem 0px 8rem 0" p="4rem 0 4rem 0" id='mixer'>
      <Container maxWidth="xl" >
        <GridWrapper container>
        
         <GridVideo
            xs={12}
            md={6}
            data-aos="fade-right"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="700"
            data-aos-offset="0"
          >
            <VideoBK autoPlay loop muted>
              <source src={Videostars} type="video/mp4" />
            </VideoBK>
          </GridVideo>
          <Grid item xs={12} md={6}>
            <SectionHeading p="20px 0" m="0" align="left" color={theme.textSecondary} data-aos="flip-up"
              data-aos-easing="fade-left"
              data-aos-delay="400"
              data-aos-duration="500"
              data-aos-offset="0" >
              <img src={arrow} width='45' />  MIXER
            </SectionHeading>
            <P p="0" m="0" color={theme.textSecondary} data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0" >A zero-knowledge mixer is a privacy-enhancing tool that allows users to obfuscate
              and mix their transactions. By pooling transactions from multiple users and
              redistributing the funds back to each user in a way that makes it difficult to trace the
              original source of each transaction, a zero-knowledge mixer effectively throws off
              would-be pursuers. This technique, known as coin mixing or coin shuffling, is
              particularly important for those who value privacy and anonymity in their
              transactions. Without this technology, transactions can be traced back to their
              original owners, potentially compromising their privacy and security.

            </P>
            <BuyNow href="/#home">Open Dapp</BuyNow>
          </Grid>
        </GridWrapper>
      </Container>
    </SectionWrapper>
  )
};

export default Section8_Team;
